<template>
  <PopUp
    ref="popup"
    bottom
    title="排序"
    :isLoading="isLoading"
    :clickOutsideClose="false"
    :popUpActive="isActiveDragPopup"
    @click="close"
  >
    <LvStateSortList :list="sortList" :titleKey="titleKey" />
    <template v-slot:bottomBtn>
      <WsButton001 outLine @click="close">
        {{ $t('取消') }}
      </WsButton001>
      <WsButton001 @click="$_onSubmit">
        {{ $t('確定') }}
      </WsButton001>
    </template>
  </PopUp>
</template>

<script>
import H_common from '@/helpers/common';

export default {
  props: {
    titleKey: {
      type: String,
      default: 'name',
    },
  },
  data() {
    return {
      isActiveDragPopup: false,
      sortList: [],
      isLoading: false,
    };
  },
  provide() {
    return {
      getPopupScrollContainer: () => {
        const popup = this.$refs.popup;
        return popup && popup.$_getScrollEl ? popup.$_getScrollEl() : null;
      },
      scrollPopupBy: (delta) => {
        const popup = this.$refs.popup;
        return popup && popup.$_scrollBy ? popup.$_scrollBy(delta) : false;
      },
      getPopupScrollBottomInset: () => {
        const popup = this.$refs.popup;
        if (!popup) return 0;
        const barHeight = popup.bottomBarHeight > 0 ? popup.bottomBarHeight : 72;
        return barHeight + 24;
      },
    };
  },
  methods: {
    open(sourceList) {
      this.sortList = H_common.deepCopyFunction(sourceList);
      this.isActiveDragPopup = true;
      this.$nextTick(() => {
        if (this.$refs.popup && this.$refs.popup.$_scrollTo) {
          this.$refs.popup.$_scrollTo(0);
        }
      });
    },
    close() {
      this.sortList = [];
      this.isActiveDragPopup = false;
    },
    $_onSubmit() {
      this.$emit('submit', this.sortList);
      this.close();
    },
    startLoading() {
      this.isLoading = true;
    },
    stopLoading() {
      this.isLoading = false;
    },
  },
};
</script>
